import type { RootState } from '~publish/legacy/store'

export const selectIsIntegrationUploading = (state: RootState) =>
  state.integrationBar.uploadInProgress
